const note = {
    version: '1.2.2',
    date: '2026-10-09',
    tags: ['Forbedret', 'Fix'],
    body: `
- **Ugen du ser er altid hentet live fra CRM.** Hver gang du åbner Kalenderen eller skifter uge, hentes den viste uge direkte fra CRM i stedet for kun at bruge de seneste 15 minutters gemte data. Ændringer lavet uden for Kalenderen vises derfor med det samme.
- **En registrering, der starter tidligt om natten, bliver på den rigtige dag.** En registrering, der startede før kl. 02:00 (kl. 01:00 om vinteren), blev gemt på dagen før og hoppede en dag tilbage i Kalenderen. Den gemmes nu på den dag, du ser den på.
- **Kalenderen viser altid dansk tid.** Også hvis din computer står på en anden tidszone, fx på rejse, er de tider du trækker eller skriver dansk tid, og registreringen bliver stående præcis der, hvor du lagde den. Før kunne den flytte sig, når den blev gemt.
- **Worktype-listen siger, hvad der sker.** Mens worktypes hentes, står der "Loading worktypes...", og kan de ikke hentes, står der en fejl med en Retry-knap. Før stod der bare "No options", så det lignede, at matteren ingen worktypes havde.
`,
};

export default note;
